import type { FC } from 'react'
import { useState, useEffect } from 'react'
import type { AnimationItem } from 'lottie-web'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import useIsInView from '@segment/utils/useInView'
import useLottie from '@segment/utils/useLottie/useLottie'

import jsonUrl from './assets/customers-are-split-lottie.json.data'

const data = {
  title: `Consumers are split about data security.`,
  content: `Consumers are divided about whether brands are acting in their best interest: 37% of consumers say they trust businesses to keep their personal data secure and use it responsibly, but another 37% don’t trust online retailers with their personal data.`,
  animation: {
    title: `Do you trust retail brands to keep your personal data secure and use it responsibly?`,
  },
}

const CustomersAreSplit: FC = () => {
  const [animationData, setAnimationData] = useState<Promise<Response>>()
  useEffect(() => {
    setAnimationData(fetch(jsonUrl))
  }, [])
  const [animation, containerRef] = useLottie<AnimationItem, HTMLDivElement>({
    options: {
      autoplay: false,
      animationData,
      loop: false,
    },
  })
  const isInView = useIsInView(containerRef)

  useEffect(() => {
    if (isInView) {
      animation?.play()
    }
  }, [animation, isInView])
  return (
    <SectionBase variant="2Col">
      <Section.Contents>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h4">
            {data.animation.title}
          </CopyText.Heading>
        </CopyTextBase>
        <Animation ref={containerRef} />
      </Section.Contents>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {data.title}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {data.content}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
    </SectionBase>
  )
}

const Animation = styled.div`
  margin: 40px auto 0 auto;
  max-width: 421px;
  aspect-ratio: 421 / 242;
`

export default CustomersAreSplit
